import { notice } from "JS/utils/notice";
import CouponForm from "./CouponForm";
import Counter from "../Counter";
import UsePoints from "JS/classes/UsePoints";

export default class Cart {

    /**
     * @type {HTMLElement}
     */
    cartPage;

    /**
     * @type {Object}
     */
    items = {};

    /**
     * @type {CouponForm}
     */
    couponForm;

    /**
     * @type {HTMLElement}
     */
    cartCounter;

     /**
     * @type {Object}
     */
    usePoints;

    /**
     * @type {number}
     */
    animationProcess = false;

    /**
     * 
     * @param {string} selector 
     */
    constructor(selector) {
        this.cartPage = document.querySelector(selector);

        if (!this.cartPage) {
            return;
        }
        this.usePoints = new UsePoints('cart', this);

        this.init();   
    }

    init() {
        this.tabBtns = Array.from(this.cartPage.querySelectorAll('[data-tab-btn]'));
        this.tabContainers = Array.from(this.cartPage.querySelectorAll('[data-tab]'));
        this.cartCounter = this.cartPage.querySelector('[data-cart-count]');
        this.cartText = this.cartPage.querySelector('[data-cart-text]');

        this.initCoupons();
        this.initItems();
        this.addQuantityListeners();
        this.addTabsListeners();

        this.setHeight();
    }

    initCoupons() {
        this.couponForm = new CouponForm(this);
    }

    calcMaxTabHeight(tab) {
        let elementHeight = null;
        elementHeight = tab.offsetHeight;
        this.tabsParent.style.height = `${elementHeight}px`;
    }

    addTabsListeners() {
        this.tabBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                this.setActiveTab(btn.dataset.tabBtn);
            });
        });
    }

    setActiveTab(slug) {
        if (this.animationProcess) {
            return;
        }

        const activeTabSlug = this.tabBtns.find(el => el.classList.contains('active'))?.dataset.tabBtn;

        if (activeTabSlug === slug) {
            return;
        }
        
        this.animationProcess = true;

        this.tabBtns.forEach(btn => {
            btn.classList.toggle('active', btn.dataset.tabBtn === slug);
        });
        
        this.tabContainers.forEach(cont => {
            if (cont.dataset.tab === slug) {
                cont.classList.add('active');
            } else if (cont.classList.contains('active')){
                cont.classList.remove('active');
                cont.classList.add('hide');
                
                setTimeout(() => {
                    cont.classList.remove('hide');
                    this.animationProcess = false;
                }, 600);
            }
            this.setHeight();
        });
    }

    removeTab(slug) {
        const btn = this.tabBtns.find(el => el.dataset.tabBtn === slug);
        const cont = this.tabContainers.find(el => el.dataset.tab === slug);

        btn.remove();
        cont.remove();

        this.tabBtns = Array.from(this.cartPage.querySelectorAll('[data-tab-btn]'));
        this.tabContainers = Array.from(this.cartPage.querySelectorAll('[data-tab]'));
    }

    setHeight() {
        const element = this.tabContainers.find(el => el.classList.contains('active'));

        if (!element) {
            return;
        }
        const height = element.clientHeight;
        const parent = element.closest('.cart-info__body-tabs');

        if (!parent) {
            return;
        }
        parent.style.height = `${height}px`;
    }

    initItems() {
        this.items = {};

        Array.from(this.cartPage.querySelectorAll('.cart-info__body-product')).forEach(el => {
            const key = el.dataset.key;

            if (!key) {
                return;
            }

            if (!this.items[key]) {
                this.items[key] = [];
            }

            this.items[key].push(el);
        });
    }

    addQuantityListeners() {
        Object.keys(this.items).forEach(key => {
            this.items[key].forEach(element => {
                const deleteBtn = element.querySelector('[data-remove-item]');
                
                if (deleteBtn && !deleteBtn.inited) {
                    deleteBtn.inited = true;
                    deleteBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.removeItems(key);
                    });
                }

                const counterEl = element.querySelector('.counter');

                if (!counterEl.counter) {
                    const counter = new Counter(counterEl);

                    if (counter) {
                        counter.on('change', (value) => {
                            this.changeQuantity(key, value);
                        });
                    }
                }
            });
        });
    }
    
    changeQuantity(key, quantity) {
        this.setDisabledItems(key);
        this.quantityRequest(key, quantity);
    }

    removeItems(key) {
        this.setDisabledItems(key);
        this.quantityRequest(key, 0);
    }

    setDisabledItems(key) {
        if (!this.items[key]) {
            return;
        }
        this.items[key].forEach(el => el.classList.add('loading'));
    }

    updateItems(key, quantity, cardHtml) {
        if (!this.items[key]) {
            return;
        }

        this.items[key].forEach(element => {
            if (quantity === 0) {
                element.remove();
                return;
            }

            const el = document.createElement('div');
            el.innerHTML = cardHtml;
            const newCard = el.querySelector('.cart-info__body-product-content');
            element.querySelector('.cart-info__body-product-content')?.replaceWith(newCard);
        });

        this.initItems();
        this.addQuantityListeners();

        this.setHeight();
    }

    quantityRequest(key, quantity) {
        const data = {
            cart_item_key: key,
            quantity: quantity,
            _quantity_nonce: backendData.quantity_nonce,
        };

        const formData = new FormData();

        formData.append('action', 'change_quantity');
        formData.append('data', JSON.stringify(data));

        this.couponForm.parent.classList.add('loading');

        fetch(backendData.ajaxUrl, {
            method: 'POST',
            body: formData,
        })
            .then((resp) => resp.json())
            .then((response) => {
                const { success, data } = response;
                
                if (success) {
                    if (data.cart_count === 0) {
                        window.location.reload();
                        return;
                    }

                    if (data.cart_count && data.separate_counts) {
                       this.setCounters(data.cart_count, data.separate_counts);
                    }
                    if (data.cart_process) {
                        this.couponForm.replaceCartProcess(data.cart_process);
                    }
                    this.updateItems(key, quantity, data.product_card);
                } else {
                    this.onError(data);
                }
            })
            .catch((error) => {
                this.onError(error);
            })
            .finally(() => {
                setTimeout(() => {
                    this.couponForm.parent.classList.remove('loading');

                    if (!this.items[key]) {
                        return;
                    }

                    this.items[key].forEach(el => el.classList.remove('loading'));
                }, 100);
            });
    }

    setCounters(count, catCounts) {
        window.cartCounter.count = count;
        this.cartCounter.dataset.cartCount = window.cartCounter.count;
        this.cartText.innerHTML = this.declOfNum(count, ['товар', 'товара', 'товаров']);

        const currentTab = this.tabContainers.find(el => el.classList.contains('active'));

        catCounts.all = count;

        Object.keys(catCounts).forEach(key => {
            const catLabel = this.cartPage.querySelector(`[data-count="${key}"]`);

            if (!catLabel) {
                return;
            }

            catLabel.innerHTML = catCounts[key];

            if (catCounts[key] === 0) {
                this.removeTab(key);
            }

            if (currentTab && currentTab.dataset.tab === key) {
                if (catCounts[currentTab.dataset.tab] !== 0) {
                    return;
                }

                const tab = Object.keys(catCounts).find(key => {
                    return key !== 'all' && catCounts[key] !== 0;
                });
                
                if (tab) {
                    this.setActiveTab(tab);
                    this.animationProcess = false;
                }
            }
        });
    }

    onError(error) {
        notice(error, 'error');
    }

    declOfNum(number, titles) {
        const cases = [2, 0, 1, 1, 1, 2];
        return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    }
}
